import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Contact, FilterParams, PaginationParams } from '../../types';

interface ContactsState {
  list: Contact[];
  selected: Contact | null;
  loading: boolean;
  error: string | null;
  filters: FilterParams;
  pagination: PaginationParams;
}

const initialState: ContactsState = {
  list: [],
  selected: null,
  loading: false,
  error: null,
  filters: {},
  pagination: { page: 1, limit: 20 },
};

const contactsSlice = createSlice({
  name: 'contacts',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setContacts: (state, action: PayloadAction<Contact[]>) => {
      state.list = action.payload;
      state.loading = false;
    },
    setSelectedContact: (state, action: PayloadAction<Contact | null>) => {
      state.selected = action.payload;
    },
    addContact: (state, action: PayloadAction<Contact>) => {
      state.list.unshift(action.payload);
    },
    updateContact: (state, action: PayloadAction<Contact>) => {
      const index = state.list.findIndex(c => c.id === action.payload.id);
      if (index !== -1) {
        state.list[index] = action.payload;
      }
      if (state.selected?.id === action.payload.id) {
        state.selected = action.payload;
      }
    },
    deleteContact: (state, action: PayloadAction<string>) => {
      state.list = state.list.filter(c => c.id !== action.payload);
      if (state.selected?.id === action.payload) {
        state.selected = null;
      }
    },
    setFilters: (state, action: PayloadAction<FilterParams>) => {
      state.filters = action.payload;
    },
    setPagination: (state, action: PayloadAction<PaginationParams>) => {
      state.pagination = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { 
  setLoading, 
  setContacts, 
  setSelectedContact, 
  addContact, 
  updateContact, 
  deleteContact, 
  setFilters, 
  setPagination, 
  setError 
} = contactsSlice.actions;
export default contactsSlice.reducer; 